import { KYMW1700Component } from './kymw1700.component';
import { KYMW0B00OutputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-output.model';
import { KYMW0B00InputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-input.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { GetImageInfoRequestModel } from './vo/get-image-info-request.model';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { GetImageInfoResponseModel } from './vo/get-image-info-response.model';
import { ImageInfoModel } from './vo/image-info.model';
import { GetPhotoContentsListOutputRequestModel } from './vo/get-photo-contents-list-output-request-model';
import { GetCodeListService } from 'src/app/commons/kymw02/api-services/get-code-list.service';

/**
 * 画像作成管理画面の値を管理するクラス
 *
 * @export KYMW1700Model
 * @class KYMW1700Model
 */
export class KYMW1700Model {

  kymw1700Component: KYMW1700Component;

  /**「画像一覧」情報のリスト */
  public imageInfoList: Array<ImageInfoModel> = new Array<ImageInfoModel>();

  // 受注コードリスト
  public orderCodeList: Array<any> = new Array<any>();

  // モード
  public mode: number = <number>0;

  public displayType: string = <string>'0';

  /** 検索条件保持用 */
  public kymw0B00Param: KYMW0B00OutputModel = null;
  public requestVO: GetImageInfoRequestModel = new GetImageInfoRequestModel();

  // 検索条件設定済みフラグ
  public existsSearchCondition: boolean = <boolean>false;

  /** スクロールの位置を保持 */
  public verticalScrollPosition: number = <number>0;

  /** ソートキー */
  public sortKey: string = <string>'';

  /** 降順または昇順 */
  public orderKey: string = <string>'';

  /** 画面作成指示ボタンの活性非活性制御用 */
  public btnImageMakeInstructionDisabled: boolean = <boolean>false;

  /** 画像個別登録ボタンの活性非活性制御用 */
  public btnImageSingleRegistDisabled: boolean = <boolean>false;

  /** 指示画像一括登録ボタンの活性非活性制御用 */
  public btnImageAllRegistDisabled: boolean = <boolean>false;

  /** 発注書・指示書出力ボタンの活性非活性制御用 */
  public btnOrderSheetOutDisabled: boolean = <boolean>false;

  /** 出力帳票選択 */
  public outputFileSelection: any[] = [];

  /** C2PFステータスコード名 */
  public c2pfStatusNames: any[] = [];

  /** 画像種類リスト */
  public imageKindList: any[] = [];

  /**
    * コンストラクタ
    */
  constructor() { }

  /**
   * サーバから取得したデータで画像一覧を更新する(表示)
   *
   * @param serverData:サーバから受信したデータ
   */
  public updateImageInfoList(dialogService: PlessDialogServiceSub, publishImageData: GetImageInfoResponseModel[], c2pfStatusNames: any[]): void {
    // 画像一覧の件数チェック
    if (publishImageData.length === 0) {
      this.imageInfoList = [];
      return;
    }
    // 該当件数2000件を越える場合はエラーメッセージを表示する
    if (publishImageData.length > 2000) {
      dialogService.openAlertGetMessage('E0182', ['2000件']);
      this.imageInfoList = [];
      return;
    }
    // 画面表示用に値を入れる
    this.imageInfoList = publishImageData.map(_ => {
      // 撮影予定日
      // yyyy/MM/dd表記で表示用の文字列作成
      const displayPhotoSchedule = PlessViewUtilsSub.isEmpty(_.PhotoSchedule) ? _.PhotoSchedule : _.PhotoSchedule.slice(0, 4) + "/" + _.PhotoSchedule.slice(4, 6) + "/" + _.PhotoSchedule.slice(6);
      // Date型の変数用
      const datePhotoSchedule = PlessViewUtilsSub.isEmpty(displayPhotoSchedule) ? displayPhotoSchedule : new Date(displayPhotoSchedule);
      // 変更前撮影予定日
      // yyyy/MM/dd表記で表示用の文字列作成
      const displayPhotographingChangeSchedule = PlessViewUtilsSub.isEmpty(_.PhotographingChangeSchedule) ? _.PhotographingChangeSchedule : _.PhotographingChangeSchedule.slice(0, 4) + "/" + _.PhotographingChangeSchedule.slice(4, 6) + "/" + _.PhotographingChangeSchedule.slice(6);
      // Date型の変数用
      const datePhotographingChangeSchedule = PlessViewUtilsSub.isEmpty(displayPhotographingChangeSchedule) ? displayPhotographingChangeSchedule : new Date(displayPhotographingChangeSchedule);
      return {
        checked: false,
        modified: false,
        startOrderCode: _.StartOrderCode,
        startDelivCatalogId: _.DelivCatalogId,
        status: _.Status,
        statusName: _.StatusName,
        className: _.ClassName,
        classCode: _.ClassCode,
        pcode: _.PCode,
        guideGoodsName: _.GuideGoodsName,
        guideStandardName: _.GuideStandardName,
        imageFileName: _.ImageFileName,
        c2pfTarget: _.C2pfTarget === '1' ? '1' : '',
        imageKind: _.ImageKind,
        imageKindName: _.ImageKindName,
        imageUseMethod: _.ImageUseMethod,
        imageUseMethodName: _.ImageUseMethodName,
        photographingNo: _.PhotographingNo,
        delivCatalogMonth: _.DelivCatalogMonth,
        delivCatalogTime: _.DelivCatalogTime,
        packaging: _.Packaging,
        plating: _.Plating,
        cookNecessary: _.CookNecessary,
        cookUnnecessary: _.CookUnnecessary,
        explain: _.Explain,
        other: _.Other,
        backSide: _.BackSide,
        tempRange: _.TempRange,
        tempRangeName: _.TempRangeName,
        multipleCode: _.MultipleCode,
        pastImageInfo: _.PastImageInfo,
        imageCaution: _.ImageCaution,
        photoContentsName: _.PhotoContentsName,
        referenceImageNum: _.ReferenceImageNum,
        billingName: _.BillingName,
        c2pfStatus: _.C2pfStatus,
        c2pfStatusName: c2pfStatusNames[_.C2pfStatus],
        delayFlag: _.DelayFlag,
        supplierAnnouncement: _.SupplierAnnouncement,
        supplierInfo: _.SupplierInfo,
        statusRemandReason: _.StatusRemandReason,
        imageInfoChange: _.ImageInfoChange,
        remarks: _.Remarks,
        photoSchedule: displayPhotoSchedule,
        datePhotoSchedule: datePhotoSchedule,
        photographingChangeSchedule: displayPhotographingChangeSchedule,
        datePhotographingChangeSchedule: datePhotographingChangeSchedule,
        carriedForward: _.CarriedForward,
        imageInstructDate: PlessViewUtilsSub.editDate(_.ImageInstructDate, '2'),
        imageInstructUserId: _.ImageInstructUserId,
        imageInstructUser: _.ImageInstructUser,
        buyerName: _.BuyerName,
        c2pfUpdateDate: _.C2pfUpdateDate,
        peaceUpdateDate: _.PeaceUpdateDate,
        printDate: _.PrintDate,
        photoStudio: _.PhotoStudio,
        janCode: _.JanCode,
        imageGroupNo: _.ImageGroupNo,
        smallClass: _.SmallClass,
        buyerCode: _.BuyerCode,
        billingCode: _.BillingCode,
        sampleOrderingCode: _.SampleOrderingCode,
        sampleOrderingName: _.SampleOrderingName,
        supplierSalesStaffName: _.SupplierSalesStaffName,
        ebaseSpecCode: _.EbaseSpecCode,
        imageId: _.ImageId,
        imageName: _.ImageName,
        enabled: _.Enabled,
        publishImageData: _.PublishImageData
      } as ImageInfoModel;
    });
  }

  /**
   * 検索失敗時の画面クリア
   */
  public clearDisplay(): void {
    this.imageInfoList = [];
  }

  /**
   * GetImageInfoVOを返却する
   *
   * @return GetImageInfoVO
   */
  public getGetImageInfoVO(outputVO: KYMW0B00OutputModel): GetImageInfoRequestModel {
    const vo: GetImageInfoRequestModel = this.requestVO;
    vo.formId = 'KYMW1700';
    vo.pcode = outputVO.pcodeList;
    vo.guideGoodsName = outputVO.guideGoodsName;
    vo.guideStandardName = outputVO.guideStandardName;
    vo.imageName = outputVO.imageName;
    vo.imageFileName = outputVO.imageFileName;
    vo.imageBelongId = outputVO.imageBelongID;
    vo.imageKind = outputVO.imageKind;
    vo.imageType = outputVO.imageType;
    vo.processInstruct = outputVO.processInstruct;
    vo.remarks = outputVO.remarks;
    vo.cookingExPublish = (outputVO.cookingExPublish === '1') ? '1' : '';
    vo.cookingDiv = outputVO.cookingDiv;
    vo.cookingName = outputVO.cookingName;
    vo.materialName = outputVO.materialName;
    vo.keyWord = outputVO.keyWord;
    vo.eventId = outputVO.eventID;
    vo.photoContentsDiv = outputVO.photoContentsDiv;
    vo.photoStudioId = outputVO.photoStudioID;
    vo.imageInstructUserId = outputVO.imageInstructUser;
    vo.imageInstructDateFrom = outputVO.imageInstructDateStart;
    vo.imageInstructDateTo = outputVO.imageInstructDateEnd;
    vo.fileRegistDateFrom = outputVO.fileRegistDateStart;
    vo.fileRegistDateTo = outputVO.fileRegistDateEnd;
    vo.status = outputVO.status;
    vo.imageInstruct = outputVO.imageInstrucrDiv;
    vo.enabled = outputVO.imageEnableDiv;
    vo.sortItem = this.sortKey;
    vo.sortOrder = this.orderKey;
    vo.page = 0;
    vo.photoScheduleFrom = outputVO.photoScheduleStart;
    vo.photoScheduleTo = outputVO.photoScheduleEnd;
    vo.studio = outputVO.studio;
    vo.classCode = outputVO.classCode;
    vo.multipleCode = outputVO.multipleCode;
    vo.startOrderCode = outputVO.startOrderCode
    vo.startDelivCatalogId = outputVO.startDelivCatalogId;
    vo.billingName = outputVO.billingName;
    vo.buyerCode = outputVO.buyerCode;
    vo.outputFlg = outputVO.outputFlg;
    vo.c2pfStatus = outputVO.c2pfStatus;
    vo.imageUseProcess = outputVO.imageUse;
    vo.carriedForward = outputVO.carriedForward;
    vo.c2pfTarget = outputVO.c2pfTarget;
    vo.photographingChangeSchedule = outputVO.photographingChangeSchedule;
    vo.supplierAnnouncement = outputVO.supplierComment;
    this.requestVO = vo;
    return vo;
  }

  /**
   * KYMW0B00InputVOを返却する
   *
   * @return KYMW0B00InputVO
   */
  public getKYMW0B00InputVO(): KYMW0B00InputModel {
    const vo: KYMW0B00InputModel = new KYMW0B00InputModel();
    vo.processDiv = '1';
    // c2pf検索項目を表示
    vo.c2pfSearchVisibleFlg = '1';
    return vo;
  }

  /**
   * 撮影リストエクセル出力用VO作成 
   * @param list 
   * @returns 
   */
  public createPhotoContentsList(list: ImageInfoModel[]) {
    // ImageInfoModel[]をGetPhotoContentsListOutputRequestModel[]に整形
    let voList = new Array();

    voList = list.map(info => {
      let vo = new GetPhotoContentsListOutputRequestModel();
      vo.startOrderCode = info.startOrderCode;
      vo.statusName = info.statusName;
      vo.classCode = info.classCode;
      vo.className = info.className;
      vo.pcode = info.pcode;
      vo.guideGoodsName = info.guideGoodsName;
      vo.guideStandardName = info.guideStandardName;
      vo.imageFileName = info.imageFileName;
      vo.c2pfTarget = info.c2pfTarget;
      vo.imageKind = info.imageKindName;
      vo.imageUseMethod = info.imageUseMethodName;
      vo.photographingNo = info.photographingNo;
      vo.delivCatalogMonth = info.delivCatalogMonth;
      vo.delivCatalogTime = info.delivCatalogTime;
      vo.packaging = info.packaging;
      vo.plating = info.plating;
      vo.cookNecessary = info.cookNecessary;
      vo.cookUnnecessary = info.cookUnnecessary;
      vo.explain = info.explain;
      vo.other = info.other;
      vo.backSide = info.backSide;
      vo.tempRange = info.tempRangeName;
      vo.multipleCode = info.multipleCode;
      vo.pastImageInfo = info.pastImageInfo;
      vo.imageCaution = info.imageCaution;
      vo.photoContentsName = info.photoContentsName;
      vo.referenceImageNum = info.referenceImageNum;
      vo.billingName = info.billingName;
      vo.c2pfStatus = info.c2pfStatusName;
      vo.delayFlag = info.delayFlag;
      vo.supplierAnnouncement = info.supplierAnnouncement;
      vo.supplierInfo = info.supplierInfo;
      vo.statusRemandReason = info.statusRemandReason;
      vo.remarks = info.remarks;
      vo.photoSchedule = info.photoSchedule;
      vo.photographingChangeSchedule = info.photographingChangeSchedule;
      vo.carriedForward = info.carriedForward;
      vo.imageInstructDate = info.imageInstructDate;
      vo.imageInstructUser = info.imageInstructUser
      vo.buyerName = info.buyerName;
      vo.c2pfUpdateDate = info.c2pfUpdateDate;
      vo.peaceUpdateDate = info.peaceUpdateDate;
      vo.printDate = info.printDate;
      vo.photoStudio = info.photoStudio;
      vo.janCode = info.janCode;
      vo.imageGroupNo = info.imageGroupNo;
      vo.smallClass = info.smallClass;
      vo.buyerCode = info.buyerCode;
      vo.billingCode = info.billingCode;
      vo.sampleOrderingCode = info.sampleOrderingCode;
      vo.sampleOrderingName = info.sampleOrderingName;
      vo.supplierSalesStaffName = info.supplierSalesStaffName;
      vo.ebaseSpecCode = info.ebaseSpecCode
      return vo;
    })

    return voList;
  }
}
